import { ReactElement } from 'react';
import { Component as MessageIcon } from 'icons/icon-ui--status-message.svg';
import { Button } from '../button/Button';
import { BannerVariant } from '../../../utils/config';
import styles from './Banner.module.scss';

type Props = {
    bannerText: string;
    bannerBoldText?: string;
    buttonText?: string;
    onClick?: () => void;
    isVisible?: boolean;
    variant: BannerVariant;
    heapId?: string;
};

function Banner({
  bannerText,
  bannerBoldText,
  buttonText,
  onClick,
  isVisible = true,
  variant,
  heapId,
}: Props): ReactElement {
  const buttonContent = {
    [BannerVariant.REACTIVATION]: {
      showButton: true,
      textClass: styles.reactivation_banner__text,
      containerClass: styles.reactivation_banner,
      showIcon: false,
    },
    [BannerVariant.ADMIN_STATUS]: {
      showButton: false,
      textClass: '',
      containerClass: styles.admin_status_banner,
      showIcon: true,
    },
  };

  return (
    <div
      className={[
        styles.banner_container,
        !isVisible && styles.hidden,
        buttonContent[variant].containerClass,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {buttonContent[variant].showIcon && (
        <div className={styles.status_message_icon}>
          <MessageIcon />
        </div>
      )}

      <div className={buttonContent[variant].textClass}>
        {bannerBoldText && <b>{bannerBoldText}</b>}
        {bannerText}
      </div>

      {buttonContent[variant].showButton && buttonText && (
        <Button text={buttonText} onClick={onClick} heapId={heapId} />
      )}
    </div>
  );
}

export default Banner;
